// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:40:47

export default {
  "id": "cannon-shooter-1",
  "slug": "cannon-shooter-1",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/254456af85f6494daed86167b890463c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/254456af85f6494daed86167b890463c/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Cannon Shooter",
      "description": "Cannon Shooter is an exciting arcade shooter where you can have endless shooting fun in fast-paced combat! You will control a cannonball firing hordes of heroic characters, facing many enemies. A quick click to launch more heroes and help you generate more heroes through the digital gate.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Shooter"
      ],
      "tags": [
        "arcade",
        "parkour",
        "stickman"
      ]
    },
    "zh-CN": {
      "title": "大炮射击者",
      "description": "《炮弹射手》是一款激动人心的街机射击游戏，您可以在快节奏的战斗中尽情享受射击的乐趣！您将控制炮弹发射出成群的英雄角色，对抗众多敌人。快速点击可以发射更多英雄，并通过数字之门生成更多英雄。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "射击游戏"
      ],
      "tags": [
        "街机",
        "跑酷",
        "棒人"
      ]
    },
    "zh-TW": {
      "title": "砲兵射擊",
      "description": "大炮射手是一款刺激的街機射擊遊戲，您可以在快節奏的戰鬥中享受無盡的射擊樂趣！您將操控一顆炮彈，發射眾多英雄角色，面對眾多敵人。快速點擊以發射更多英雄，並透過數位閘門生成更多英雄幫助您。",
      "instructions": "滑鼠點擊或觸控玩遊戲",
      "genres": [
        "射手"
      ],
      "tags": [
        "電玩",
        "疾走跳躍",
        "木人"
      ]
    },
    "zh-HK": {
      "title": "砲兵射手",
      "description": "大砲射手是一款刺激的街機射擊遊戲，讓你在快節奏的戰鬥中享受無盡的射擊樂趣！你將操控一顆砲彈，發射眾多英雄角色，對抗眾多敵人。快速點擊即可發射更多英雄，並透過數位閘門生成更多英雄來幫助你。",
      "instructions": "滑鼠點擊或觸碰以遊玩",
      "genres": [
        "射擊遊戲"
      ],
      "tags": [
        "電玩場",
        "攀擊跳躍",
        "木人形"
      ]
    },
    "ja": {
      "title": "カノンシューター",
      "description": "キャノンシューターは、高速な戦闘で無限に射撃の楽しみを味わえるスリル満点のアーケードシューターゲームです！あなたはキャノン玉を発射し、英雄たちの大群を敵に向けて攻撃します。速くクリックしてさらに英雄たちを送り込み、デジタルゲートを通じて英雄たちを生成しましょう。",
      "instructions": "マウスクリックまたはタップして遊ぶ",
      "genres": [
        "シューティングゲーム"
      ],
      "tags": [
        "アーケード",
        "パークアウト",
        "スティックマン"
      ]
    },
    "ko": {
      "title": "캐년 쏘커",
      "description": "캐논 쏘터는 빠른 전투 속에서 끝없는 쏘기 재미를 즐길 수 있는 흥미로운 아케이드 쏘터입니다! 캐논 공을 쏘아 많은 영웅적인 캐릭터들로 적들을 물리치는 것을 제어하며, 많은 적들을 맞습니다. 빠른 클릭으로 더 많은 영웅들을 발사하고 디지털 게이트를 통해 더 많은 영웅들을 생성해 주세요.",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "射手"
      ],
      "tags": [
        "어케이드",
        "파크라이",
        "스티커맨"
      ]
    },
    "fr": {
      "title": "Tir de Canon",
      "description": "Cannon Shooter est un jeu d'arcade shooter captivant où vous pouvez vivre des heures de plaisir de tir à l'infini dans des combats à allure rapide ! Vous contrôlerez une boule de canon qui tire des hordes de personnages héroïques, confrontés à de nombreux ennemis. Un clic rapide pour lancer plus de héros et vous aider à générer plus de héros grâce à la porte digitale.",
      "instructions": "Cliquez avec la souris ou appuyez pour jouer",
      "genres": [
        "Tirailleur d'élite"
      ],
      "tags": [
        "arcade",
        "parkour",
        "stickman\n\n- arcade : arcade\n- parkour : parkour\n- stickman : stickman"
      ]
    }
  }
};
